<section>
  <app-days-panel *ngIf="leadQuestionInformation.leadId != 7"
    #daysPanel
    [days]="commitmentDetails"
    (selectedDay)="getSelectedDay($event)"
  ></app-days-panel>
  <form
    [formGroup]="dailyCommitmentForm"
    id="daily-commitment-form"
    (submit)="submitDailyCommitmentForm()"
  >
    <div *ngFor="let question of questions.questions; index as i">
      <div class="p-grid">
        <div class="p-col daily-commitment-form-question p-col-12">
          {{ question.question }}
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col daily-commitment-form-answer">

          <div *ngIf="question.questionType == 'Yes/No'">
            <p-radioButton
              [formControlName]="'control-' + question.index"
              [disableControl]="!canUseForm()"
              [inputId]="question.index + '-commitment-response-yes'"
              label="Yes"
              (click)="onSelect(question.index)"
              [name]="'control-' + question.index"
              value="Y"
            ></p-radioButton>
            <p-radioButton
              class="radio-btn"
              [disableControl]="!canUseForm()"
              [formControlName]="'control-' + question.index"
              [inputId]="question.index + '-commitment-response-no'"
              (click)="onSelect(question.index)"
              label="No"
              [name]="'control-' + question.index"
              value="N"
            ></p-radioButton>
          </div>

          <div *ngIf="question.questionType == 'Date'" class="p-field p-col-12 p-sm-6 p-md-4 p-lg-2 cre-question-answer">
            <p-calendar
              #calendar
              [disableControl]="!canUseForm()"
              [formControlName]="'control-' + question.index"
              readonlyInput="true"
              appendTo="body"
              class="calendar"
              dateFormat="mm-dd-yy"
              hourFormat="24"
              placeholder="MM-DD-YYYY HH:MM"
              [showIcon]="true"
              [showTime]="true"
              placeholder="Select Date"
            >
              <p-footer class="calendar-footer">
                <button
                (click)="calendar.hideOverlay()"
                label="Close"
                pButton
                type="button"
                ></button>
              </p-footer>
            </p-calendar>
          </div>

          <div *ngIf="question.questionType === 'ThreeDaysDriveHours'"
          class="p-field p-col-12 cre-question-answer">
            <div class="p-grid">
              <div class="p-col-4">
                <input
                  [disableControl]="!canUseForm()"
                  class="p-col-12 day-hours"
                  [formControlName]="'control-day1-' + question.index"
                  pInputText
                  placeholder="Day 1"
                  type="number"
                />
              </div>
              <div class="p-col-4">
                <input
                  [disableControl]="!canUseForm()"
                  class="p-col-12 day-hours"
                  [formControlName]="'control-day2-' + question.index"
                  pInputText
                  placeholder="Day 2"
                  type="number"
                />
              </div>
              <div class="p-col-4">
                <input
                 [disableControl]="!canUseForm()"
                  class="p-col-12 day-hours"
                  [formControlName]="'control-day3-' + question.index"
                  pInputText
                  placeholder="Day 3"
                  type="number"
                />
              </div>
            </div>
          </div>

          <div *ngIf="question.questionType === 'MultipleChoice'">
            <div *ngFor="let response of question.possibleResponses;let responseIndex = index">
              <div class="p-col-5">
                <p-radioButton
                  [formControlName]="'control-' + question.index"
                  [disableControl]="!canUseForm()"
                  [inputId]="question.index + '-responseMultichoice-' + questions.index + '-' +  responseIndex"
                  label="{{response}}"
                  (click)="onSelect(question.index)"
                  [name]="'control-' + question.index"
                  value="{{response}}"
                ></p-radioButton>
              </div>
            </div>
          </div>

          <div *ngIf="question.questionType === 'MultipleSelect'">
            <div *ngFor="let response of question.possibleResponses;let responseIndex = index">
              <div class="p-col-5">
                <p-checkbox
                  [disableControl]="!canUseForm()"
                  [formControlName]="'control-' + question.index + '-response-' + responseIndex"
                  value="{{response}}"
                  (click)="onSelectCheck(question.index, $event, response)"
                  label="{{response}}"
                ></p-checkbox>
              </div>
            </div>
          </div>

          <div *ngIf="question.questionType === 'Text'">
            <div class="p-col-5">
              <input
              [disableControl]="!canUseForm()"
              [formControlName]="'control-' + question.index"
              maxlength="{{question.stringAnswerMaxLength}}"
              pInputText
              type="text"
              />
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="p-grid">
      <p-button
        class="p-col-12 submit-btn"
        [disabled]="!canSubmit()"
        form="daily-commitment-form"
        label="Submit"
        type="submit"
        *ngIf="!isFormSubmitted"
      ></p-button>
    </div>
    <p-messages [(value)]="errors"></p-messages>
  </form>
</section>

<div class="p-grid p-justify-center">
  <cre-spinner [size]="'sm'" [hidden]="!isFormSubmitted"></cre-spinner>
</div>
